import { BiLeftArrowAlt } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams, Link } from "react-router";
import {
  ROUTE_PRODUCTS_LIST,
  ROUTE_PRODUCT_SPOTLIGHT,
  ROUTE_PRODUCT_SUCCESSCRITERIA,
} from "../../SharedModule/utils/constants";
import { TabLabel } from "../../SharedModule/components/TabLabel";
import { CheckSkeleton } from "../../SharedModule/utils/checkSkeleton";
import { setIsLoadingDataSpotlight } from "../redux/reducers/spotlight.reducer";
import { setIsLoadingDataCriteria } from "../redux/reducers/successCriteria.reducer";

export default function HeaderProductsModule({
  actualProductName,
  isLoadingDataHeader = true,
}: Readonly<{
  actualProductName?: string;
  isLoadingDataHeader?: boolean;
}>) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { productId } = useParams();

  let id = productId ? productId : "";

  const checkActiveTab = (tab: string) => {
    return location.pathname.endsWith(tab);
  };

  const onClickHandler = (route: string, id: string) => {
    if (route === ROUTE_PRODUCT_SPOTLIGHT) {
      dispatch(setIsLoadingDataSpotlight(true));
    } else {
      dispatch(setIsLoadingDataCriteria(true));
    }
    navigate(route.replace(":productId", id));
  };

  return (
    <div className="header-module-container">
      <Link
        className="back-button-container text-decoration-none"
        to={ROUTE_PRODUCTS_LIST}
      >
        <BiLeftArrowAlt className="back-button-arrow" />
        <span className="back-button-text">Back to Product List</span>
      </Link>
      <CheckSkeleton
        isLoading={isLoadingDataHeader}
        style={{ width: "40%", lineHeight: "25px", marginTop: "5px" }}
      >
        <div className="header-module-title">Product: {actualProductName}</div>
      </CheckSkeleton>
      <div className="d-flex flex-row mt-3">
        <TabLabel
          key="spotlight"
          active={checkActiveTab("spotlight")}
          classes="top-nav-tab"
          disabled={isLoadingDataHeader}
          onClick={() => onClickHandler(ROUTE_PRODUCT_SPOTLIGHT, id)}
        >
          <div
            className={`header-module-link ${
              isLoadingDataHeader ? "disabled" : ""
            }`}
          >
            Spotlight
          </div>
        </TabLabel>
        <TabLabel
          key="successCriteria"
          active={checkActiveTab("successCriteria")}
          classes="top-nav-tab"
          disabled={isLoadingDataHeader}
          onClick={() => onClickHandler(ROUTE_PRODUCT_SUCCESSCRITERIA, id)}
        >
          <div
            className={`header-module-link ${
              isLoadingDataHeader ? "disabled" : ""
            }`}
          >
            Success Criteria
          </div>
        </TabLabel>
      </div>
      <hr className="header-separator" />
    </div>
  );
}
